{
  "dashboard.title": "ロイヤリティダッシュボード",
  "actionReferralReportDownloadButton.tooltip": "紹介プログラムレポートは、紹介情報を含む CSV ファイルです。ダウンロードには数分かかる場合があります。",
  "actionReferralReportDownloadButton.label": "紹介プログラムレポートをダウンロード",
  "referralRevenueWidget.title": "純収益と投資収益率",
  "referralRevenueWidget.roiTotals.title": "投資収益率",
  "referralRevenueWidget.roiTotals.titleTooltip": "選択した期間の純収益を投資額で割ったもの。",
  "referralRevenueWidget.investmentTotals.title": "投資額",
  "referralRevenueWidget.investmentTotals.titleTooltip": "選択した期間の購入に使用される紹介バウチャーの費用合計。",
  "referralRevenueWidget.revenueTotals.title": "純収益",
  "referralRevenueWidget.revenueTotals.titleTooltip": "選択した期間の紹介による購入から得られた総収益からすべての割引を差し引いたもの。",
  "referralRevenueWidget.chartMetaData.displayName.revenue": "純収益",
  "referralRevenueWidget.chartMetaData.displayName.investment": "投資額",
  "referralRevenueWidget.chartMetaData.displayName.roi": "投資収益率",
  "referralSucccessWidget.chartMetaData.diaplayName.successRate": "契約成功率",
  "referralSucccessWidget.successRate.title": "契約成功率",
  "referralSucccessWidget.successRate.titleTooltip": "選択した期間に、紹介を受けた友人が購入のために引き換えた紹介コードの割合。Smart Insight の最新の設定に基づきます。",
  "referralSucccessWidget.title": "紹介の成功率",
  "referralVouchersWidget.title": "紹介バウチャー",
  "referralVouchersWidget.redeemedTotal.title": "引き換え済みのバウチャー",
  "referralVouchersWidget.redeemedTotal.titleTooltip": "紹介を受けた友人が購入のために引き換えた紹介コードの総数。",
  "referralVouchersWidget.issuedTotal.title": "発行済みのバウチャー",
  "referralVouchersWidget.issuedTotal.titleTooltip": "ロイヤリティメンバーが紹介する友人に送信した紹介コードの総数。",
  "referralVouchersWidget.chartMetaData.issuedVouchers.displayName": "発行済みのバウチャー",
  "referralVouchersWidget.chartMetaData.redeemedVouchers.displayName": "引き換え済みのバウチャー",
  "averageOrderValueWidget.title": "平均注文額",
  "averageOrderValueWidget.totals.nonLoyaltyMembers": "非ロイヤリティメンバー",
  "averageOrderValueWidget.totals.loyaltyMembers": "ロイヤリティメンバー",
  "averageOrderValueWidget.totals.uplift": "ロイヤリティアップリフト",
  "averageOrderValueWidget.chart.nonLoyaltyMembers": "非ロイヤリティメンバー",
  "averageOrderValueWidget.chart.loyaltyMembers": "ロイヤリティメンバー",
  "dashboardEmptyState.title": " 表示するデータがありません。",
  "dashboardEmptyState.lead": "表示するデータがありません。",
  "dashboardView.loyaltyImpact.title": "ロイヤリティインパクト",
  "dashboardView.numOfMembersWidget.title": "ロイヤリティメンバーの増加",
  "dashboardView.engagementRatesWidget.title": "ロイヤリティエンゲージメント",
  "dashboardView.pointsAnalyticsWidget.title": "特典分析",
  "engagementRatesWidget.title": "エンゲージメント率",
  "engagementRatesWidget.totalsEngagement.ratePct.title": "ロイヤリティエンゲージメント率",
  "engagementRatesWidget.totalsRedemption.ratePct.title": "ポイントエンゲージメント率",
  "inThePastDays": "過去 {selectedDaysRange} 日間",
  "engagementRatesWidget.mainSeries.redemtion.name": "ポイント引き換え率",
  "engagementRatesWidget.redemptionRateWidget.title": "ポイント引き換え率",
  "engagementRatesWidget.redemptionRateWidget.titleTooltip": "選択した期間に特典に引き換えられた総ポイントの割合。Smart Insight の最新の設定に基づきます。",
  "engagementRatesWidget.engagementRateWidget.titleTooltip": "選択した期間に購入やアクションによってポイントを貯めたり、ポイントを特典に引き換えたりしたメンバーの割合。",
  "engagementRatesWidget.engagementRateWidget.title": "ロイヤリティエンゲージメント率",
  "engagementRatesWidget.chartMetaData.main.displayName": "ロイヤリティエンゲージメント率",
  "enrollmentsWidget.title": "ロイヤリティ加入",
  "enrollmentsWidget.totals.leadTotal.title": "加入したリード",
  "enrollmentsWidget.totals.customerTotal.title": "加入したメンバー",
  "enrollmentsWidget.totals.enrollTotal.title": "加入者合計",
  "enrollmentsWidget.tooltip.label": "ロイヤリティ加入",
  "enrollmentsWidget.chartMetaData.customer.displayName": "メンバー",
  "enrollmentsWidget.chartMetaData.lead.displayName": "リード",
  "generatedRevenueWidget.title": "ロイヤリティメンバー収益",
  "generatedRevenueWidget.widgetCollapsedContentElement.totalRevenue.title": "総売上",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyRevenue.title": "ロイヤリティ収益",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyImpactPct.title": "ロイヤリティ収益インパクト",
  "generatedRevenueWidget.chartDataTotalRevenue.name": "総売上",
  "generatedRevenueWidget.chartDataLoyaltyRevenue.name": "ロイヤリティ収益",
  "generatedRevenueWidget.totals.loyaltyImpactPct.titleTooltip": "ロイヤリティプログラムがもたらした総収益の割合。",
  "generatedRevenueWidget.totals.loyaltyImpactPct.title": "ロイヤリティ収益インパクト",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.title": "ロイヤリティアクション収益",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.titleTooltip": "メンバーが実行したロイヤリティアクションがもたらした収益。",
  "generatedRevenueWidget.totals.loyaltyRevenue.title": "ロイヤリティ総収益",
  "generatedRevenueWidget.totals.loyaltyRevenue.titleTooltip": "選択した期間にロイヤリティメンバーがもたらした総収益。",
  "generatedRevenueWidget.totals.totalRevenue.title": "総売上",
  "generatedRevenueWidget.totals.totalRevenue.titleTooltip": "総売上には、選択した期間の販売データに基づくすべての購入が計上されます。これには、総売上の減少につながる返品 (返金) も含まれます。",
  "generatedRevenueWidget.chartTooltipContent.totalRevenue.label": "総売上",
  "generatedRevenueWidget.chartTooltipContent.loyaltyRevenue.label": "ロイヤリティ総収益",
  "generatedRevenueWidget.chartTooltipContent.totalActionRevenue.label": "ロイヤリティアクション収益",
  "generatedRevenueWidget.chartTooltipContent.loyaltyImpactPct.label": "ロイヤリティ収益インパクト",
  "numOfMembersWidget.title": "ロイヤリティメンバー合計",
  "numOfMembersWidget.total.title": "ロイヤリティメンバー",
  "numOfMembersWidget.chartTooltipContent.label": "ロイヤリティメンバー",
  "pointsAnalyticsWidget.title.spend": "クレジット分析",
  "pointsAnalyticsWidget.title.points": "ポイント分析",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.displayName": "累計クレジット",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.totalsTooltip": "選択した期間に承認されたクレジットの総計。",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.displayName": "累計キャッシュバック",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.totalsTooltip": "選択した期間に承認されたキャッシュバックの総額。",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.displayName": "保留クレジット",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.totalsTooltip": "選択した期間に保留になっていたクレジットの総計。",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.displayName": "期限切れクレジット",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.totalsTooltip": "選択した期間に期限が切れたクレジットの総計。",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.displayName": "累計ポイント",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.totalsTooltip": "選択した期間に承認されたポイントの総計。",
  "pointsAnalyticsWidget.chartMetadata.points.pending.displayName": "保留ポイント",
  "pointsAnalyticsWidget.chartMetadata.points.pending.totalsTooltip": "選択した期間に保留になっていたポイントの総計。",
  "pointsAnalyticsWidget.chartMetadata.points.expired.displayName": "期限が切れた/削除されたポイント",
  "pointsAnalyticsWidget.chartMetadata.points.expired.totalsTooltip": "選択した期間に期限が切れた/削除されたポイントの総計。",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.displayName": "引き換えられたポイント",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.totalsTooltip": "選択した期間に引き換えられたポイントの総計。",
  "purchaseFrequencyWidget.title": "時間枠における購入回数",
  "purchaseFrequencyWidget.tooltip": "選択した時間枠におけるメンバーの平均購入回数。Smart Insight の最新の設定に基づきます。",
  "purchaseFrequencyWidget.totalsMetaData.loyalty.title": "ロイヤリティメンバー",
  "purchaseFrequencyWidget.totalsMetaData.nonLoyalty.title": "非ロイヤリティメンバー",
  "purchaseFrequencyWidget.totalsMetaData.uplift.title": "ロイヤリティアップリフト",
  "vouchersAnalyticsWidget.title": "バウチャー分析",
  "vouchersAnalyticsWidget.rewardMetaData.displayName": "特典としてのバウチャー",
  "vouchersAnalyticsWidget.rewardMetaData.totalsTooltip": "選択した期間に完了したアクションの特典として、またバウチャーコードで表示された固定会員特典として積算されたバウチャーの総数。",
  "vouchersAnalyticsWidget.pointsMetaData.displayName": "ポイントのバウチャー",
  "vouchersAnalyticsWidget.pointsMetaData.totalsTooltip": "選択した期間にバウチャーコードでポイントが表示されたバウチャーの総数。",
  "vouchersAnalyticsWidget.freeMetaData.displayName": "無料のバウチャー",
  "vouchersAnalyticsWidget.freeMetaData.totalsTooltip": "選択した期間に無料のコードが表示されたバウチャーの総数。",
  "vouchersAnalyticsWidget.cashbackMetaData.displayName": "キャッシュバックのバウチャー",
  "vouchersAnalyticsWidget.cashbackMetaData.totalsTooltip": "選択した期間にキャッシュバックのコードが表示されたバウチャーの総数。",
  "widgetHelpLink.tooltip": "このデータの計算方法を表示",
  "viewRange.options.day": "日",
  "viewRange.options.week": "週",
  "viewRange.options.month": "月"
}
